// Register PWA service worker (production builds)
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Avoid breaking dev HMR
  const isLocalhost = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
  // Allow in all envs; service worker gracefully handles failures
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn("SW registration failed:", err);
    });
  });
}
